import { HttpClient, JSON_STRING, MAIN_STRING } from "../http/http-client";

const i18nURL = '/i18n.pl';


export const I18nService = {
  getLanguageDict: (lang = 'en', section = MAIN_STRING) => {
    return HttpClient.get(i18nURL, {
      section,
      lang,
      output: JSON_STRING
    }).then(res => {
      return res.data;
    });
  }
};